'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
  async getPurchases(id, params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `direct-purchases/${id}${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async getPurchaseNextNo(id) {
    const data = {
      method: 'get',
      url: 'direct-purchaseNextNo/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async createPurchase(json) {
    const data = {
      method: 'post',
      url: 'direct-purchase',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Direct purchase added successfully')
      return true;
    }
  },
  async getPurchase(id) {
    const data = {
      method: 'get',
      url: 'direct-purchase/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async getPurchaseDetails(id, params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `direct-purchase/${id}/details${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return {data: [], total: 0}
  },
  async createPurchaseDetails(json) {
    const data = {
      method: 'post',
      url: 'direct-purchase-details',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Purchase product added', 2000)
      return true;
    }
  },
  async updatePurchaseDetails(json, id) {
    const data = {
      method: 'put',
      url: 'direct-purchase-details/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Purchase product updated', 2000)
      return true;
    }
  },
  async deletePurchaseDetails(id) {
    const data = {
      method: 'delete',
      url: 'direct-purchase-details/' + id
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Purchase product deleted', 2000)
      return true;
    }
  },
  async changePurchaseStatus(body, id) {
    const data = {
      method: 'patch',
      url: 'direct-purchase-status/' + id,
      body: body,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Purchase submitted successfully')
      window.location.reload();
    }
  },
  async addSupplierInvoice(json) {
    const data = {
      method: 'post',
      url: 'direct-purchase-supplier-invoice',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Supplier invoice added successfully')
      return true;
    }
  },
}
